<template>
    <div class="sms-management">
      <!-- <h2 class="page-title">短信管理</h2> -->
  
      <el-tabs v-model="activeTab" type="border-card">
        <!-- 发送短信选项卡 -->
        <el-tab-pane label="发送短信" name="send">
          <div class="send-sms-container">
            <!-- 选择短信模板 -->
            <el-card class="box-card">
              <div slot="header" class="card-header">
                <span>选择短信模板</span>
                <el-button type="text" icon="el-icon-document" @click="viewTemplates">查看全部模板</el-button>
              </div>
              
              <el-form :inline="true" :model="templateSearchForm" size="small">
                <el-form-item label="模板名称">
                  <el-input v-model="templateSearchForm.name" placeholder="请输入模板名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="模板分类">
                  <el-select v-model="templateSearchForm.category" placeholder="请选择分类" clearable>
                    <el-option label="门诊服务" value="outpatient"></el-option>
                    <el-option label="住院服务" value="inpatient"></el-option>
                    <el-option label="随访管理" value="follow-up"></el-option>
                    <el-option label="健康教育" value="education"></el-option>
                    <el-option label="营销活动" value="marketing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="模板类型">
                  <el-select v-model="templateSearchForm.type" placeholder="请选择类型" clearable>
                    <el-option label="预约提醒" value="appointment"></el-option>
                    <el-option label="随访提醒" value="follow-up"></el-option>
                    <el-option label="检查结果" value="test-result"></el-option>
                    <el-option label="复诊提醒" value="revisit"></el-option>
                    <el-option label="用药提醒" value="medication"></el-option>
                    <el-option label="缴费通知" value="payment"></el-option>
                    <el-option label="节日问候" value="holiday"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchTemplates">查询</el-button>
                  <el-button icon="el-icon-refresh" @click="resetTemplateSearch">重置</el-button>
                </el-form-item>
              </el-form>
              
              <el-table
                :data="filteredTemplates"
                border
                style="width: 100%"
                @selection-change="handleTemplateSelectionChange"
                v-loading="templateLoading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="ID" width="70"></el-table-column>
                <el-table-column prop="name" label="模板名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="短信内容" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="类型" width="120">
                  <template slot-scope="scope">
                    <el-tag :type="getTypeTagType(scope.row.type)">{{ scope.row.type }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="previewTemplate(scope.row)">预览</el-button>
                    <el-button type="text" size="small" @click="selectTemplate(scope.row)">选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
              
              <div class="template-pagination">
                <el-pagination
                  @size-change="handleTemplateSizeChange"
                  @current-change="handleTemplateCurrentChange"
                  :current-page="templatePagination.currentPage"
                  :page-sizes="[5, 10, 20, 30]"
                  :page-size="templatePagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="templatePagination.total">
                </el-pagination>
              </div>
            </el-card>
            
            <!-- 选择发送对象 -->
            <el-card class="box-card" v-if="selectedTemplate">
              <div slot="header" class="card-header">
                <span>选择发送对象</span>
                <div>
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="showPatientList = true">添加患者</el-button>
                  <el-button size="small" type="warning" icon="el-icon-upload" @click="importPatients">批量导入</el-button>
                </div>
              </div>
              
              <div class="selected-template">
                <div class="template-info">
                  <span class="label">已选模板：</span>
                  <el-tag>{{ selectedTemplate.name }}</el-tag>
                </div>
                <div class="template-content">
                  <span class="label">模板内容：</span>
                  <div class="content-box">{{ selectedTemplate.content }}</div>
                  <div class="content-note">
                    <i class="el-icon-info"></i> 
                    支持变量：${patient_name}、${appointment_time}、${doctor_name}、${department}、${hospital_name}
                  </div>
                </div>
              </div>
              
              <el-divider content-position="left">已选择的发送对象 ({{ selectedPatients.length }})</el-divider>
              
              <el-table
                :data="selectedPatients"
                border
                style="width: 100%">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="name" label="患者姓名" width="100"></el-table-column>
                <el-table-column prop="gender" label="性别" width="60"></el-table-column>
                <el-table-column prop="age" label="年龄" width="60"></el-table-column>
                <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
                <el-table-column prop="department" label="就诊科室" width="120"></el-table-column>
                <el-table-column prop="doctor" label="主治医生" width="100"></el-table-column>
                <el-table-column prop="diagnosis" label="诊断信息" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native.prevent="removeSelectedPatient(scope.$index)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              
              <div class="no-data" v-if="selectedPatients.length === 0">
                <i class="el-icon-warning-outline"></i>
                <p>请选择患者作为短信接收对象</p>
              </div>
              
              <!-- 发送选项 -->
              <div class="send-options" v-if="selectedPatients.length > 0">
                <el-form :inline="true" size="small">
                  <el-form-item label="定时发送">
                    <el-switch v-model="scheduleEnabled"></el-switch>
                  </el-form-item>
                  <el-form-item label="发送时间" v-if="scheduleEnabled">
                    <el-date-picker
                      v-model="scheduleTime"
                      type="datetime"
                      placeholder="选择发送时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="{
                        disabledDate(time) {
                          return time.getTime() < Date.now() - 8.64e7;
                        }
                      }">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
              
              <div class="action-buttons">
                <el-button @click="saveAsDraft" :disabled="selectedPatients.length === 0">存为草稿</el-button>
                <el-button type="success" @click="sendMessages" :disabled="selectedPatients.length === 0">
                  立即发送 {{ selectedPatients.length ? `(${selectedPatients.length}条)` : '' }}
                </el-button>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
        
        <!-- 发送记录选项卡 -->
        <el-tab-pane label="发送记录" name="history">
          <div class="history-container">
            <!-- 搜索条件 -->
            <el-form :inline="true" :model="historySearchForm" size="small" class="search-form">
              <el-form-item label="发送状态">
                <el-select v-model="historySearchForm.status" placeholder="请选择状态" clearable>
                  <el-option label="发送成功" value="success"></el-option>
                  <el-option label="发送失败" value="fail"></el-option>
                  <el-option label="待发送" value="pending"></el-option>
                  <el-option label="发送中" value="sending"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板类型">
                <el-select v-model="historySearchForm.type" placeholder="请选择类型" clearable>
                  <el-option label="预约提醒" value="appointment"></el-option>
                  <el-option label="随访提醒" value="follow-up"></el-option>
                  <el-option label="检查结果" value="test-result"></el-option>
                  <el-option label="复诊提醒" value="revisit"></el-option>
                  <el-option label="用药提醒" value="medication"></el-option>
                  <el-option label="缴费通知" value="payment"></el-option>
                  <el-option label="节日问候" value="holiday"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接收患者">
                <el-input v-model="historySearchForm.patient" placeholder="请输入患者姓名"></el-input>
              </el-form-item>
              <el-form-item label="发送时间">
                <el-date-picker
                  v-model="historySearchForm.dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchHistory">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetHistorySearch">重置</el-button>
              </el-form-item>
            </el-form>
            
            <!-- 记录表格 -->
            <el-tabs v-model="historySubTab" @tab-click="handleHistoryTabClick">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="发送成功" name="success">
                <span slot="label">发送成功 <el-badge :value="successCount" class="badge" type="success" v-if="successCount > 0"></el-badge></span>
              </el-tab-pane>
              <el-tab-pane label="发送失败" name="fail">
                <span slot="label">发送失败 <el-badge :value="failCount" class="badge" type="danger" v-if="failCount > 0"></el-badge></span>
              </el-tab-pane>
              <el-tab-pane label="待发送" name="pending">
                <span slot="label">待发送 <el-badge :value="pendingCount" class="badge" v-if="pendingCount > 0"></el-badge></span>
              </el-tab-pane>
            </el-tabs>
            
            <el-table
              :data="filteredHistory"
              border
              stripe
              style="width: 100%"
              v-loading="historyLoading">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="message-detail">
                    <el-form-item label="短信内容">
                      <div class="sms-content">{{ props.row.content }}</div>
                    </el-form-item>
                    <el-form-item v-if="props.row.failReason" label="失败原因">
                      <span class="fail-reason">{{ props.row.failReason }}</span>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column prop="id" label="消息ID" width="80"></el-table-column>
              <el-table-column prop="templateName" label="模板名称" min-width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="type" label="类型" width="100">
                <template slot-scope="scope">
                  <el-tag size="small" :type="getTypeTagType(scope.row.type)">{{ scope.row.type }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="patientName" label="接收患者" width="100"></el-table-column>
              <el-table-column prop="phone" label="接收号码" width="120"></el-table-column>
              <el-table-column prop="sendTime" label="发送时间" width="150"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status === 'success' ? 'success' : 
                           scope.row.status === 'fail' ? 'danger' : 
                           scope.row.status === 'pending' ? 'info' : 'warning'"
                    size="small">
                    {{ 
                      scope.row.status === 'success' ? '发送成功' : 
                      scope.row.status === 'fail' ? '发送失败' : 
                      scope.row.status === 'pending' ? '待发送' : '发送中'
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="viewMessageDetail(scope.row)">详情</el-button>
                  <el-button 
                    type="text" 
                    size="small" 
                    @click="resendMessage(scope.row)"
                    v-if="scope.row.status === 'fail'">重发</el-button>
                  <el-button 
                    type="text" 
                    size="small" 
                    @click="cancelSchedule(scope.row)"
                    v-if="scope.row.status === 'pending'">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <div class="history-pagination">
              <el-pagination
                @size-change="handleHistorySizeChange"
                @current-change="handleHistoryCurrentChange"
                :current-page="historyPagination.currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="historyPagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="historyPagination.total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      
      <!-- 患者选择对话框 -->
      <el-dialog title="选择患者" :visible.sync="showPatientList" width="900px">
        <div class="patient-dialog-content">
          <el-form :inline="true" :model="patientSearchForm" size="small">
            <el-form-item label="患者姓名">
              <el-input v-model="patientSearchForm.name" placeholder="请输入患者姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="就诊科室">
              <el-select v-model="patientSearchForm.department" placeholder="请选择科室" clearable>
                <el-option label="内科" value="内科"></el-option>
                <el-option label="外科" value="外科"></el-option>
                <el-option label="儿科" value="儿科"></el-option>
                <el-option label="妇产科" value="妇产科"></el-option>
                <el-option label="眼科" value="眼科"></el-option>
                <el-option label="口腔科" value="口腔科"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="就诊状态">
              <el-select v-model="patientSearchForm.visitStatus" placeholder="请选择状态" clearable>
                <el-option label="就诊中" value="就诊中"></el-option>
                <el-option label="已出院" value="已出院"></el-option>
                <el-option label="复诊" value="复诊"></el-option>
                <el-option label="随访中" value="随访中"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchPatients">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetPatientSearch">重置</el-button>
            </el-form-item>
          </el-form>
          
          <el-table
            ref="patientTable"
            :data="filteredPatients"
            border
            @selection-change="handlePatientSelectionChange"
            style="width: 100%"
            max-height="400px"
            v-loading="patientLoading">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="患者姓名" width="100"></el-table-column>
            <el-table-column prop="gender" label="性别" width="60"></el-table-column>
            <el-table-column prop="age" label="年龄" width="60"></el-table-column>
            <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
            <el-table-column prop="department" label="就诊科室" width="100"></el-table-column>
            <el-table-column prop="doctor" label="主治医生" width="100"></el-table-column>
            <el-table-column prop="diagnosis" label="诊断信息" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="visitStatus" label="就诊状态" width="90">
              <template slot-scope="scope">
                <el-tag size="small" :type="scope.row.visitStatus === '已出院' ? 'success' : 'primary'">
                  {{ scope.row.visitStatus }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          
          <div class="patient-pagination">
            <el-pagination
              @size-change="handlePatientSizeChange"
              @current-change="handlePatientCurrentChange"
              :current-page="patientPagination.currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="patientPagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="patientPagination.total">
            </el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showPatientList = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelectPatients">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 短信预览对话框 -->
      <el-dialog title="短信预览" :visible.sync="showPreview" width="500px" center>
        <div class="sms-preview">
          <div class="phone-mockup">
            <div class="phone-header">
              <span>中国移动</span>
              <span>{{ currentTime }}</span>
              <span>100%</span>
            </div>
            <div class="phone-content">
              <div class="message-bubble">
                <div class="message-sender">短信服务 <span class="time">{{ currentTime }}</span></div>
                <div class="message-content">{{ previewContent }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-test" v-if="previewTemplate">
          <p><strong>测试变量替换:</strong></p>
          <el-button size="small" @click="fillTestData">填充示例数据</el-button>
          <div class="test-result" v-if="previewRenderedContent">
            <p>替换后内容:</p>
            <div class="test-content">{{ previewRenderedContent }}</div>
          </div>
        </div>
      </el-dialog>
      
      <!-- 消息详情对话框 -->
      <el-dialog title="短信详情" :visible.sync="showMessageDetail" width="600px">
        <el-descriptions border :column="1" v-if="currentMessage">
          <el-descriptions-item label="消息ID">{{ currentMessage.id }}</el-descriptions-item>
          <el-descriptions-item label="模板名称">{{ currentMessage.templateName }}</el-descriptions-item>
          <el-descriptions-item label="接收患者">{{ currentMessage.patientName }}</el-descriptions-item>
          <el-descriptions-item label="接收号码">{{ currentMessage.phone }}</el-descriptions-item>
          <el-descriptions-item label="发送时间">{{ currentMessage.sendTime }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag
              :type="currentMessage.status === 'success' ? 'success' : 
                     currentMessage.status === 'fail' ? 'danger' : 
                     currentMessage.status === 'pending' ? 'info' : 'warning'">
              {{ 
                currentMessage.status === 'success' ? '发送成功' : 
                currentMessage.status === 'fail' ? '发送失败' : 
                currentMessage.status === 'pending' ? '待发送' : '发送中'
              }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="短信内容">
            <div class="message-content-box">{{ currentMessage.content }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="失败原因" v-if="currentMessage.failReason">
            <div class="message-fail-reason">{{ currentMessage.failReason }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="发送者">{{ currentMessage.sender || '系统' }}</el-descriptions-item>
        </el-descriptions>
      </el-dialog>
      
      <!-- 发送结果提示 -->
      <el-dialog title="发送结果" :visible.sync="showSendResult" width="450px" center>
        <div class="send-result">
          <div class="result-icon" :class="sendResult.success ? 'success' : 'fail'">
            <i :class="sendResult.success ? 'el-icon-success' : 'el-icon-error'"></i>
          </div>
          <div class="result-message">{{ sendResult.message }}</div>
          <div class="result-detail" v-if="sendResult.detail">
            <p>成功: {{ sendResult.detail.success }} 条</p>
            <p>失败: {{ sendResult.detail.fail }} 条</p>
            <p>待发送: {{ sendResult.detail.pending }} 条</p>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showSendResult = false">确 定</el-button>
          <el-button v-if="sendResult.detail && sendResult.detail.fail > 0" @click="viewFailDetail">查看失败详情</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SmsManagement',
    data() {
      return {
        // 当前活动选项卡
        activeTab: 'send',
        historySubTab: 'all',
        
        // 模板相关数据
        templateSearchForm: {
          name: '',
          category: '',
          type: ''
        },
        templates: [],
        filteredTemplates: [],
        templateLoading: false,
        selectedTemplate: null,
        multipleTemplates: [],
        templatePagination: {
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        
        // 患者相关数据
        patientSearchForm: {
          name: '',
          department: '',
          visitStatus: ''
        },
        patients: [],
        filteredPatients: [],
        selectedTempPatients: [], // 临时选择的患者
        selectedPatients: [], // 确认选择的患者
        patientLoading: false,
        showPatientList: false,
        patientPagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        
        // 发送选项
        scheduleEnabled: false,
        scheduleTime: '',
        
        // 历史记录相关数据
        historySearchForm: {
          status: '',
          type: '',
          patient: '',
          dateRange: []
        },
        messageHistory: [],
        filteredHistory: [],
        historyLoading: false,
        historyPagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        
        // 状态统计
        successCount: 0,
        failCount: 0,
        pendingCount: 0,
        
        // 预览相关
        showPreview: false,
        previewTemplate: null,
        previewContent: '',
        previewRenderedContent: '',
        currentTime: '',
        
        // 消息详情
        showMessageDetail: false,
        currentMessage: null,
        
        // 发送结果
        showSendResult: false,
        sendResult: {
          success: true,
          message: '',
          detail: null
        }
      }
    },
    created() {
      this.fetchTemplates();
      this.fetchPatients();
      this.fetchHistory();
      this.updateCurrentTime();
      setInterval(this.updateCurrentTime, 60000); // 每分钟更新一次时间
    },
    methods: {
      // === 工具方法 ===
      updateCurrentTime() {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        this.currentTime = `${hours}:${minutes}`;
      },
      
      getTypeTagType(type) {
        const typeMap = {
          '预约提醒': 'primary',
          '随访提醒': 'success',
          '检查结果': 'info',
          '复诊提醒': 'warning',
          '用药提醒': 'danger',
          '缴费通知': '',
          '节日问候': 'success'
        };
        return typeMap[type] || '';
      },
      
      // === 模板相关方法 ===
      fetchTemplates() {
        this.templateLoading = true;
        
        // 模拟API请求延迟
        setTimeout(() => {
          // 模拟模板数据
          this.templates = [
            {
              id: '1001',
              name: '门诊预约提醒',
              content: '尊敬的${patient_name}，您预约的${hospital_name}${department}${doctor_name}医生的门诊，时间为${appointment_time}，请提前半小时到达医院。如需取消，请提前致电取消。',
              type: '预约提醒',
              category: '门诊服务'
            },
            {
              id: '1002',
              name: '复诊提醒模板',
              content: '${patient_name}您好，根据医生建议，您的复诊时间为${appointment_time}，请按时前往${hospital_name}${department}就诊，祝您早日康复！',
              type: '复诊提醒',
              category: '随访管理'
            },
            {
              id: '1003',
              name: '检查报告通知',
              content: '尊敬的${patient_name}，您在${hospital_name}的检查报告已出，请登录医院APP查看或前往医院领取纸质报告。如有疑问请咨询您的主治医生。',
              type: '检查结果',
              category: '门诊服务'
            },
            {
              id: '1004',
              name: '用药提醒',
              content: '${patient_name}您好，请记得按医嘱按时服用药物，保持良好的生活习惯。如有不适，请及时就医。祝您健康！',
              type: '用药提醒',
              category: '随访管理'
            },
            {
              id: '1005',
              name: '满意度调查',
              content: '尊敬的${patient_name}，感谢您近期在${hospital_name}就诊，为提升服务质量，诚邀您参与满意度调查，请点击链接完成调查，谢谢！',
              type: '满意度调查',
              category: '门诊服务'
            },
            {
              id: '1006',
              name: '新年祝福',
              content: '尊敬的${patient_name}，${hospital_name}全体医护人员恭祝您新年快乐，身体健康，万事如意！',
              type: '节日问候',
              category: '健康教育'
            },
            {
              id: '1007',
              name: '缴费通知',
              content: '${patient_name}您好，您在${hospital_name}有￥XXX元医疗费用未结算，请及时到医院收费处或通过医院APP完成支付。',
              type: '缴费通知',
              category: '门诊服务'
            },
            {
              id: '1008',
              name: '随访提醒',
              content: '${patient_name}您好，根据您的病情，医生安排在${appointment_time}对您进行随访，请保持电话畅通，如有疑问请联系${doctor_name}医生。',
              type: '随访提醒',
              category: '随访管理'
            }
          ];
          
          this.templatePagination.total = this.templates.length;
          this.updateFilteredTemplates();
          this.templateLoading = false;
        }, 500);
      },
      
      searchTemplates() {
        this.templatePagination.currentPage = 1;
        this.updateFilteredTemplates();
      },
      
      resetTemplateSearch() {
        this.templateSearchForm = {
          name: '',
          category: '',
          type: ''
        };
        this.searchTemplates();
      },
      
      updateFilteredTemplates() {
        let result = [...this.templates];
        
        // 应用过滤条件
        if (this.templateSearchForm.name) {
          result = result.filter(t => t.name.includes(this.templateSearchForm.name));
        }
        
        if (this.templateSearchForm.category) {
          result = result.filter(t => t.category === this.templateSearchForm.category);
        }
        
        if (this.templateSearchForm.type) {
          result = result.filter(t => t.type === this.templateSearchForm.type);
        }
        
        this.templatePagination.total = result.length;
        
        // 分页处理
        const start = (this.templatePagination.currentPage - 1) * this.templatePagination.pageSize;
        const end = start + this.templatePagination.pageSize;
        this.filteredTemplates = result.slice(start, end);
      },
      
      handleTemplateSizeChange(val) {
        this.templatePagination.pageSize = val;
        this.updateFilteredTemplates();
      },
      
      handleTemplateCurrentChange(val) {
        this.templatePagination.currentPage = val;
        this.updateFilteredTemplates();
      },
      
      handleTemplateSelectionChange(val) {
        this.multipleTemplates = val;
      },
      
      viewTemplates() {
        this.$message({
          message: '查看全部模板功能已启用',
          type: 'info'
        });
      },
      
      selectTemplate(template) {
        this.selectedTemplate = { ...template };
      },
      
      previewTemplate(template) {
        this.previewTemplate = template;
        this.previewContent = template.content;
        this.previewRenderedContent = '';
        this.showPreview = true;
      },
      
      fillTestData() {
        if (!this.previewTemplate) return;
        
        const testData = {
          patient_name: '许昊然',
          appointment_time: '2023-04-15 上午9:30',
          doctor_name: '王医生',
          department: '内科',
          hospital_name: '仁爱医院'
        };
        
        // 替换变量
        let content = this.previewTemplate.content;
        for (const [key, value] of Object.entries(testData)) {
          content = content.replace(new RegExp(`\\$\\{${key}\\}`, 'g'), value);
        }
        
        this.previewRenderedContent = content;
      },
      
      // === 患者相关方法 ===
      fetchPatients() {
        // 模拟API请求延迟
        this.patientLoading = true;
        setTimeout(() => {
          // 模拟患者数据
          this.patients = [
            {
              id: 'P001',
              name: '许昊然',
              gender: '男',
              age: 45,
              phone: '13800138000',
              department: '内科',
              doctor: '李医生',
              diagnosis: '高血压、糖尿病',
              visitStatus: '复诊'
            },
            {
              id: 'P002',
              name: '苏雅婷',
              gender: '男',
              age: 32,
              phone: '13900139000',
              department: '外科',
              doctor: '王医生',
              diagnosis: '腰椎间盘突出',
              visitStatus: '就诊中'
            },
            {
              id: 'P003',
              name: '林书辰',
              gender: '男',
              age: 28,
              phone: '13700137000',
              department: '骨科',
              doctor: '赵医生',
              diagnosis: '髌骨骨折',
              visitStatus: '随访中'
            },
            {
              id: 'P004',
              name: '程若曦',
              gender: '女',
              age: 38,
              phone: '13600136000',
              department: '妇产科',
              doctor: '钱医生',
              diagnosis: '子宫肌瘤',
              visitStatus: '已出院'
            },
            {
              id: 'P005',
              name: '郭子轩',
              gender: '女',
              age: 25,
              phone: '13500135000',
              department: '眼科',
              doctor: '孙医生',
              diagnosis: '近视、散光',
              visitStatus: '就诊中'
            },
            {
              id: 'P006',
              name: '韩宇航',
              gender: '男',
              age: 62,
              phone: '13400134000',
              department: '内科',
              doctor: '李医生',
              diagnosis: '冠心病',
              visitStatus: '随访中'
            },
            {
              id: 'P007',
              name: '江语涵',
              gender: '女',
              age: 42,
              phone: '13300133000',
              department: '口腔科',
              doctor: '郑医生',
              diagnosis: '牙周炎',
              visitStatus: '复诊'
            },
            {
              id: 'P008',
              name: '沈思妍',
              gender: '男',
              age: 35,
              phone: '13200132000',
              department: '外科',
              doctor: '王医生',
              diagnosis: '阑尾炎',
              visitStatus: '已出院'
            },
            {
              id: 'P009',
              name: '郑十一',
              gender: '女',
              age: 30,
              phone: '13100131000',
              department: '皮肤科',
              doctor: '杨医生',
              diagnosis: '湿疹',
              visitStatus: '就诊中'
            },
            {
              id: 'P010',
              name: '王十二',
              gender: '男',
              age: 55,
              phone: '13000130000',
              department: '内科',
              doctor: '李医生',
              diagnosis: '肝硬化',
              visitStatus: '随访中'
            }
          ];
          
          this.patientPagination.total = this.patients.length;
          this.updateFilteredPatients();
          this.patientLoading = false;
        }, 500);
      },
      
      searchPatients() {
        this.patientPagination.currentPage = 1;
        this.updateFilteredPatients();
      },
      
      resetPatientSearch() {
        this.patientSearchForm = {
          name: '',
          department: '',
          visitStatus: ''
        };
        this.searchPatients();
      },
      
      updateFilteredPatients() {
        let result = [...this.patients];
        
        // 应用过滤条件
        if (this.patientSearchForm.name) {
          result = result.filter(p => p.name.includes(this.patientSearchForm.name));
        }
        
        if (this.patientSearchForm.department) {
          result = result.filter(p => p.department === this.patientSearchForm.department);
        }
        
        if (this.patientSearchForm.visitStatus) {
          result = result.filter(p => p.visitStatus === this.patientSearchForm.visitStatus);
        }
        
        this.patientPagination.total = result.length;
        
        // 分页处理
        const start = (this.patientPagination.currentPage - 1) * this.patientPagination.pageSize;
        const end = start + this.patientPagination.pageSize;
        this.filteredPatients = result.slice(start, end);
      },
      
      handlePatientSizeChange(val) {
        this.patientPagination.pageSize = val;
        this.updateFilteredPatients();
      },
      
      handlePatientCurrentChange(val) {
        this.patientPagination.currentPage = val;
        this.updateFilteredPatients();
      },
      
      handlePatientSelectionChange(val) {
        this.selectedTempPatients = val;
      },
      
      confirmSelectPatients() {
        // 合并已选患者和新选患者，去重
        const existingIds = this.selectedPatients.map(p => p.id);
        const newPatients = this.selectedTempPatients.filter(p => !existingIds.includes(p.id));
        this.selectedPatients = [...this.selectedPatients, ...newPatients];
        this.showPatientList = false;
      },
      
      removeSelectedPatient(index) {
        this.selectedPatients.splice(index, 1);
      },
      
      importPatients() {
        this.$message({
          message: '导入患者功能即将推出',
          type: 'info'
        });
      },
      
      // === 发送相关方法 ===
      saveAsDraft() {
        if (!this.selectedTemplate || this.selectedPatients.length === 0) {
          this.$message.warning('请选择短信模板和发送对象');
          return;
        }
        
        // 模拟保存草稿
        setTimeout(() => {
          this.$message({
            message: '已保存到草稿箱',
            type: 'success'
          });
        }, 500);
      },
      
      sendMessages() {
        if (!this.selectedTemplate || this.selectedPatients.length === 0) {
          this.$message.warning('请选择短信模板和发送对象');
          return;
        }
        
        // 模拟发送短信
        setTimeout(() => {
          // 模拟部分成功部分失败的情况
          const total = this.selectedPatients.length;
          const success = Math.floor(total * 0.9); // 假设90%成功
          const fail = total - success;
          const pending = this.scheduleEnabled ? total : 0; // 如果是定时发送，则全部为待发送
          
          this.sendResult = {
            success: true,
            message: this.scheduleEnabled 
              ? `已成功安排 ${total} 条短信在 ${this.scheduleTime} 发送` 
              : `成功发送 ${success} 条短信，失败 ${fail} 条`,
            detail: {
              success: this.scheduleEnabled ? 0 : success,
              fail: this.scheduleEnabled ? 0 : fail,
              pending: this.scheduleEnabled ? pending : 0
            }
          };
          
          this.showSendResult = true;
          
          // 添加到发送历史
          if (this.scheduleEnabled) {
            this.addPendingMessages();
          } else {
            this.addSentMessages();
          }
        }, 1000);
      },
      
      addSentMessages() {
        // 模拟添加发送记录到历史
        const now = new Date();
        const successCount = Math.floor(this.selectedPatients.length * 0.9);
        
        this.selectedPatients.forEach((patient, index) => {
          const isSuccess = index < successCount; // 前90%成功，后10%失败
          const message = {
            id: `M${Date.now()}${index}`,
            templateId: this.selectedTemplate.id,
            templateName: this.selectedTemplate.name,
            type: this.selectedTemplate.type,
            patientName: patient.name,
            phone: patient.phone,
            sendTime: now.toLocaleString(),
            status: isSuccess ? 'success' : 'fail',
            content: this.selectedTemplate.content
              .replace(/\$\{patient_name\}/g, patient.name)
              .replace(/\$\{department\}/g, patient.department)
              .replace(/\$\{doctor_name\}/g, patient.doctor),
            failReason: isSuccess ? '' : '网络异常，发送失败'
          };
          
          this.messageHistory.unshift(message);
        });
        
        // 更新计数
        this.updateStatusCounts();
        this.fetchHistory(); // 刷新显示
      },
      
      addPendingMessages() {
        // 模拟添加待发送记录到历史
        this.selectedPatients.forEach((patient, index) => {
          const message = {
            id: `M${Date.now()}${index}`,
            templateId: this.selectedTemplate.id,
            templateName: this.selectedTemplate.name,
            type: this.selectedTemplate.type,
            patientName: patient.name,
            phone: patient.phone,
            sendTime: this.scheduleTime,
            status: 'pending',
            content: this.selectedTemplate.content
              .replace(/\$\{patient_name\}/g, patient.name)
              .replace(/\$\{department\}/g, patient.department)
              .replace(/\$\{doctor_name\}/g, patient.doctor)
          };
          
          this.messageHistory.unshift(message);
        });
        
        // 更新计数
        this.updateStatusCounts();
        this.fetchHistory(); // 刷新显示
      },
      
      viewFailDetail() {
        this.activeTab = 'history';
        this.historySubTab = 'fail';
        this.showSendResult = false;
        this.fetchHistory();
      },
      
      // === 历史记录相关方法 ===
      fetchHistory() {
        this.historyLoading = true;
        
        // 模拟API请求
        setTimeout(() => {
          // 应用过滤条件
          this.updateFilteredHistory();
          this.updateStatusCounts();
          this.historyLoading = false;
        }, 500);
      },
      
      searchHistory() {
        this.historyPagination.currentPage = 1;
        this.fetchHistory();
      },
      
      resetHistorySearch() {
        this.historySearchForm = {
          status: '',
          type: '',
          patient: '',
          dateRange: []
        };
        this.searchHistory();
      },
      
      updateFilteredHistory() {
        // 根据子选项卡过滤
        let result = [...this.messageHistory];
        if (this.historySubTab !== 'all') {
          result = result.filter(m => m.status === this.historySubTab);
        }
        
        // 应用搜索过滤条件
        if (this.historySearchForm.status) {
          result = result.filter(m => m.status === this.historySearchForm.status);
        }
        
        if (this.historySearchForm.type) {
          result = result.filter(m => m.type === this.historySearchForm.type);
        }
        
        if (this.historySearchForm.patient) {
          result = result.filter(m => m.patientName.includes(this.historySearchForm.patient));
        }
        
        if (this.historySearchForm.dateRange && this.historySearchForm.dateRange.length === 2) {
          const startDate = new Date(this.historySearchForm.dateRange[0]);
          const endDate = new Date(this.historySearchForm.dateRange[1]);
          endDate.setHours(23, 59, 59, 999); // 设置为当天结束时间
          
          result = result.filter(m => {
            const sendTime = new Date(m.sendTime);
            return sendTime >= startDate && sendTime <= endDate;
          });
        }
        
        this.historyPagination.total = result.length;
        
        // 分页处理
        const start = (this.historyPagination.currentPage - 1) * this.historyPagination.pageSize;
        const end = start + this.historyPagination.pageSize;
        this.filteredHistory = result.slice(start, end);
      },
      
      updateStatusCounts() {
        this.successCount = this.messageHistory.filter(m => m.status === 'success').length;
        this.failCount = this.messageHistory.filter(m => m.status === 'fail').length;
        this.pendingCount = this.messageHistory.filter(m => m.status === 'pending').length;
      },
      
      handleHistorySizeChange(val) {
        this.historyPagination.pageSize = val;
        this.updateFilteredHistory();
      },
      
      handleHistoryCurrentChange(val) {
        this.historyPagination.currentPage = val;
        this.updateFilteredHistory();
      },
      
      handleHistoryTabClick() {
        this.historyPagination.currentPage = 1;
        this.updateFilteredHistory();
      },
      
      viewMessageDetail(message) {
        this.currentMessage = message;
        this.showMessageDetail = true;
      },
      
      resendMessage(message) {
        // 模拟重发
        this.$confirm('确定要重新发送此短信吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: `已重新发送短信至 ${message.patientName}(${message.phone})`
          });
          
          // 更新状态
          const index = this.messageHistory.findIndex(m => m.id === message.id);
          if (index > -1) {
            this.messageHistory[index].status = 'success';
            this.messageHistory[index].sendTime = new Date().toLocaleString();
            this.messageHistory[index].failReason = '';
          }
          
          // 更新显示
          this.updateFilteredHistory();
          this.updateStatusCounts();
        }).catch(() => {});
      },
      
      cancelSchedule(message) {
        this.$confirm('确定要取消此条定时短信吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: `已取消定时短信`
          });
          
          // 从历史中删除
          const index = this.messageHistory.findIndex(m => m.id === message.id);
          if (index > -1) {
            this.messageHistory.splice(index, 1);
          }
          
          // 更新显示
          this.updateFilteredHistory();
          this.updateStatusCounts();
        }).catch(() => {});
      }
    }
  }
  </script>
  
  <style scoped>
  .sms-management {
    padding: 20px;
  }
  
  .page-title {
    margin-bottom: 20px;
    font-weight: 500;
    color: #303133;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .template-pagination, .patient-pagination, .history-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .selected-template {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 5px;
  }
  
  .template-info {
    margin-bottom: 10px;
  }
  
  .label {
    font-weight: bold;
    margin-right: 10px;
  }
  
  .content-box {
    padding: 10px;
    background-color: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  
  .content-note {
    color: #909399;
    font-size: 12px;
  }
  
  .send-options {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .action-buttons {
    margin-top: 20px;
    text-align: center;
  }
  
  .no-data {
    text-align: center;
    padding: 30px 0;
    color: #909399;
  }
  
  .no-data i {
    font-size: 40px;
    margin-bottom: 10px;
  }
  
  .search-form {
    margin-bottom: 20px;
  }
  
  .message-detail {
    padding: 15px;
  }
  
  .sms-content {
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    line-height: 1.5;
  }
  
  .fail-reason {
    color: #f56c6c;
  }
  
  .sms-preview {
    display: flex;
    justify-content: center;
  }
  
  .phone-mockup {
    width: 280px;
    border: 10px solid #dcdfe6;
    border-radius: 20px;
    overflow: hidden;
  }
  
  .phone-header {
    height: 30px;
    background-color: #f2f6fc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    color: #606266;
    font-size: 12px;
  }
  
  .phone-content {
    background-color: #f5f7fa;
    padding: 15px;
    min-height: 200px;
  }
  
  .message-bubble {
    background-color: #ecf5ff;
    border-radius: 8px;
    padding: 12px;
    width: 80%;
    margin-left: auto;
    border: 1px solid #d9ecff;
  }
  
  .message-sender {
    font-size: 12px;
    color: #909399;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
  }
  
  .message-content {
    color: #303133;
    word-break: break-word;
  }
  
  .time {
    color: #c0c4cc;
  }
  
  .preview-test {
    margin-top: 20px;
  }
  
  .test-result {
    margin-top: 10px;
  }
  
  .test-content {
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px dashed #dcdfe6;
    color: #409EFF;
  }
  
  .patient-dialog-content {
    max-height: 500px;
  }
  
  .message-content-box {
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    line-height: 1.5;
  }
  
  .message-fail-reason {
    color: #f56c6c;
  }
  
  .send-result {
    text-align: center;
    padding: 20px 0;
  }
  
  .result-icon {
    font-size: 60px;
    margin-bottom: 20px;
  }
  
  .result-icon.success {
    color: #67C23A;
  }
  
  .result-icon.fail {
    color: #F56C6C;
  }
  
  .result-message {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .result-detail {
    text-align: left;
    width: 200px;
    margin: 0 auto;
  }
  
  .result-detail p {
    margin: 5px 0;
  }
  
  .badge {
    margin-top: -2px;
  }
  </style>